import {
  NetworkClientListClientLineItem,
  NetworkClientListHeaderText,
  NetworkClientListHeaderTextFrameName,
  NetworkClientListHeaderTextFrameMac,
  NetworkClientListHeaderTextFrameIP,
  NetworkClientListHeaderTextFrameDevice,
  NetworkClientListHeaderTextFrameProtocol,
  NetworkClientListHeaderTextFrameBand,
  NetworkClientListHeaderTextFrameSSID,
  NetworkClientListHeaderTextFrameBytes,
  NetworkClientListHeaderTextFrameConnected,
} from './style'
import { SiteClients } from '../../types'
import { SpinnerCentered } from 'components/Loader'

interface ClientLineItemProps {
  siteClient: SiteClients
}

function ClientLineItem({ siteClient }: ClientLineItemProps) {
  function formatMac(mac: string) {
    return (
      mac.slice(0, 2) +
      ':' +
      mac.slice(2, 4) +
      ':' +
      mac.slice(4, 6) +
      ':' +
      mac.slice(6, 8) +
      ':' +
      mac.slice(8, 10) +
      ':' +
      mac.slice(10, 12)
    )
  }

  function formatBytes(bytes: number, decimals = 2) {
    if (!+bytes) return '0 Bytes'
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
  }

  function formatTotalBytes() {
    const totalBytes = siteClient.rx_bytes + siteClient.tx_bytes
    return formatBytes(totalBytes, 2)
  }

  function formatHostname() {
    if (siteClient.hostname !== '' && siteClient.hostname !== undefined) {
      return siteClient.hostname
    } else if (siteClient.family !== '' && siteClient.family !== undefined) {
      return siteClient.family + ' ' + siteClient.model
    } else if (
      siteClient.manufacture !== '' &&
      siteClient.family !== undefined
    ) {
      return siteClient.manufacture
    } else {
      return 'Unknown'
    }
  }

  function formatBand(band: string) {
    let formatband = band
    band === '24' ? (formatband = '2.4') : (formatband = band)

    return formatband
  }

  function formatUptime(uptime: number) {
    if (isNaN(uptime) || uptime == null) {
      return 'N/A'
    } else if (uptime >= 86400) {
      return Math.round(uptime / 86400) + ' days'
    } else if (uptime >= 3600) {
      return Math.round(uptime / 3600) + ' hours'
    } else {
      return Math.round(uptime / 60) + ' mins'
    }
  }

  return (
    <>
      {siteClient.mac === ' ' ? (
        <SpinnerCentered mt="200px" />
      ) : (
        <NetworkClientListClientLineItem key={siteClient.mac}>
          <NetworkClientListHeaderTextFrameName>
            <NetworkClientListHeaderText>
              <b>{formatHostname()}</b>
            </NetworkClientListHeaderText>
          </NetworkClientListHeaderTextFrameName>

          <NetworkClientListHeaderTextFrameMac>
            <NetworkClientListHeaderText>
              {formatMac(siteClient.mac)}
            </NetworkClientListHeaderText>
          </NetworkClientListHeaderTextFrameMac>

          <NetworkClientListHeaderTextFrameIP>
            <NetworkClientListHeaderText>
              {siteClient.ip}
            </NetworkClientListHeaderText>
          </NetworkClientListHeaderTextFrameIP>

          <NetworkClientListHeaderTextFrameDevice>
            <NetworkClientListHeaderText>
              {siteClient.manufacture}
            </NetworkClientListHeaderText>
          </NetworkClientListHeaderTextFrameDevice>

          <NetworkClientListHeaderTextFrameProtocol>
            <NetworkClientListHeaderText>
              802.11{siteClient.proto}
            </NetworkClientListHeaderText>
          </NetworkClientListHeaderTextFrameProtocol>

          <NetworkClientListHeaderTextFrameBand>
            <NetworkClientListHeaderText>
              {formatBand(siteClient.band)} GHz
            </NetworkClientListHeaderText>
          </NetworkClientListHeaderTextFrameBand>

          <NetworkClientListHeaderTextFrameSSID>
            <NetworkClientListHeaderText>
              {siteClient.ssid}
            </NetworkClientListHeaderText>
          </NetworkClientListHeaderTextFrameSSID>

          <NetworkClientListHeaderTextFrameBytes>
            <NetworkClientListHeaderText>
              {formatTotalBytes()}
            </NetworkClientListHeaderText>
          </NetworkClientListHeaderTextFrameBytes>

          <NetworkClientListHeaderTextFrameConnected>
            <NetworkClientListHeaderText>
              {formatUptime(siteClient.uptime)}
            </NetworkClientListHeaderText>
          </NetworkClientListHeaderTextFrameConnected>
        </NetworkClientListClientLineItem>
      )}
    </>
  )
}

export default ClientLineItem
